/*
 *
 * SignUpPage actions
 *
 */

import {
  SIGN_UP_REQUEST,
  SIGN_UP_SUCCESS,
  SIGN_UP_FAILURE,
  RESEND_VERIFICATION_REQUEST,
  RESEND_VERIFICATION_SUCCESS,
  RESEND_VERIFICATION_FAILURE,
} from './constants';

export const signUpRequest = (payload) => ({
  type: SIGN_UP_REQUEST,
  payload
});

export const signUpSuccess = (payload) => ({
  type: SIGN_UP_SUCCESS,
  payload
});

export const signUpFailure = (payload) => ({
  type: SIGN_UP_FAILURE,
  payload
});

export const resendVerificationRequest = (payload) => ({
  type: RESEND_VERIFICATION_REQUEST,
  payload
});

export const resendVerificationSuccess = (payload) => ({
  type: RESEND_VERIFICATION_SUCCESS,
  payload
});

export const resendVerificationFailure = ({errors}) => {
  return ({
  type: RESEND_VERIFICATION_FAILURE,
  errors
})};



// WEBPACK FOOTER //
// ./src/containers/SelfSignUp/actions.js